<p-dialog header="Remove Image" [(visible)]="showRemoveImageDialog" [modal]="true" [style]="{width: '400px'}"
		  [draggable]="false" [resizable]="false">
	<p class="m-0">
		Do you really want to remove {{selectedImageType === merchantImageTypeEnum.StoreImage ? 'Store' : 'Cover'}} Image?<br>
		Warning: This action cannot be undone!
	</p>
	<ng-template pTemplate="footer">
		<p-button icon="pi pi-times" (click)="showRemoveImageDialog=false" label="Cancel" styleClass="p-button-text"></p-button>
		<p-button icon="pi pi-trash" [disabled]="loading" (click)="removeMerchantImage()" label="Remove" styleClass="p-button-text"></p-button>
	</ng-template>
</p-dialog>

<upload-store-image *ngIf="showUpdateStoreSidebar" [visible]="showUpdateStoreSidebar" [onHide]="handleHideUpdateStore"></upload-store-image>
<library-store-images [onHide]="handleHideImagesLibrary" [visible]="showImagesLibrary" [coverImageUrl]="merchantData.CoverImageUrl" [storeImageUrl]="merchantData.StoreImageUrl"></library-store-images>

<div class="flex flex-row">
	<div class="partner-store-branding-label">{{merchantData.TradingName}}</div>
	<button pButton pRipple label="Image Library" class="p-button-outlined p-button-info" (click)="handleShowImagesLibrary()" style="margin-left: auto"></button>
	<button pButton pRipple label="Upload" class="btn-darkblue" (click)="handleShowUpdateStore()" style="margin-left: 20px;"></button>
</div>
<div class="flex flex-row">

	<div *ngIf="merchantData.StoreImageUrl">
		<div class="mos-stores-name">Current Store Image</div>
		<div class="mos-stores-block">
			<div class="mos-stores-img-response">
				<img class="mos-stores-img" src="{{merchantData.StoreImageUrl}}" />
			</div>

			<div style="display: flex; position: absolute; right: 11px; bottom: 14px; z-index: 3; grid-gap: 20px;">
				<button pButton pRipple label="Remove" class="outlined-red-btn" style="padding: 0 10px;" (click)="handleShowRemoveImageDialog(merchantImageTypeEnum.StoreImage)"></button>

				<button pButton pRipple label="Change" class="btn-darkblue" (click)="handleShowUpdateStore()"></button>

			</div>
		</div>
	</div>
	<div *ngIf="merchantData.CoverImageUrl">
		<div class="mos-stores-name">Current Cover Image</div>
		<div class="mos-stores-block">
			<div class="mos-stores-img-response">
				<img class="mos-stores-img" src="{{merchantData.CoverImageUrl}}" />
			</div>

			<div style="display: flex; position: absolute; right: 11px; bottom: 14px; z-index: 3; grid-gap: 20px; ">
				<button pButton pRipple label="Remove" class="outlined-red-btn" style="padding: 0 10px;" (click)="handleShowRemoveImageDialog(merchantImageTypeEnum.CoverImage)"></button>

				<button pButton pRipple label="Change" class="btn-darkblue" (click)="handleShowUpdateStore()"></button>
			</div>

		</div>
	</div>
</div>
